// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"27638":"a3c7f615","44050":"9ee9ba4d","56137":"d29d1330","59555":"31d6cfe0"}[chunkId] + ".chunk.css";
};